import { FC } from 'react';

import { FormattedMessage } from 'react-intl';

import { IRecoveryNoticeProps } from './recovery-notice.interface';
import styles from './recovery-notice.module.scss';

import { Button } from 'views/components/UI/Button';
import { Hint } from 'views/components/UI/Hint';
import { Text } from 'views/components/UI/Text';

// Presentation only: callers retain their existing request and recovery policy.
const RecoveryNotice: FC<IRecoveryNoticeProps> = ({
  children,
  action,
  mode = 'danger',
  role = 'alert',
}) => (
  <div role={role}>
    <Hint mode={mode}>
      <div className={styles.content}>
        <Text variant="bodySmall" color="inherit" className={styles.message}>
          {children}
        </Text>
        {action && (
          <Button
            type="button"
            mode="secondary"
            color="dark"
            className={styles.action}
            onClick={action.onClick}
            disabled={action.disabled}
            aria-label={action.ariaLabel}
          >
            {action.label ?? <FormattedMessage id="common.try-again" />}
          </Button>
        )}
      </div>
    </Hint>
  </div>
);

export { RecoveryNotice };
